import { MemberDetailResponseType } from '../../types';
import { TFunction } from 'i18next';
import { capitalizeFirstLetter } from '../../utils/texts';
import { Link } from 'react-router-dom';
import { UrlParamsUsedForNavigationType } from '../../types/DirectMemberComparisonItemPropsType';

export function formatMemberNameForComparison(name: string): JSX.Element | string {
    if (window.innerWidth < 1200) {
        const nameParts = name.split(' ');
        if (nameParts.length === 3) {
            return (
                <>
                    {nameParts[0]}
                    <br />
                    {nameParts[1][0]}. {nameParts[2]}
                </>
            );
        } else if (name.length > 13) {
            return (
                <>
                    {nameParts[0]}
                    <br />
                    {nameParts[1]}
                </>
            );
        }
    }
    return name;
}

export function formatMemberActivityForComparison(
    isActive: '1' | '0',
    memberData: MemberDetailResponseType | null,
    t: TFunction
): string {
    const pohlavi = memberData ? memberData.pohlavi : undefined;

    return Boolean(isActive)
        ? `${capitalizeFirstLetter(t('active', { ns: 'translation' }))} ${t('member', {
              ns: 'translation',
              context: pohlavi
          })}`
        : `${capitalizeFirstLetter(t('inactive', { ns: 'translation' }))} ${t('member', {
              ns: 'translation',
              context: pohlavi
          })}`;
}

export function formatMandateForComparison(
    mandate: number,
    memberData: MemberDetailResponseType | null,
    t: TFunction
): string {
    const totalNumOfMandates = memberData ? memberData.dochazka.celkem_zasedani : undefined;

    if (mandate === totalNumOfMandates) {
        return `${capitalizeFirstLetter(t('whole', { ns: 'translation' }))} ${t('term-short', {
            ns: 'translation'
        })}`;
    }
    return `${t('x-out-of-y', { ns: 'translation', x: mandate, y: totalNumOfMandates })} ${t('meetings')}`;
}

export function formatPartyForComparison(
    partyData: MemberDetailResponseType['politicke_strany'][0],
    memberData: MemberDetailResponseType | null,
    t: TFunction,
    params: UrlParamsUsedForNavigationType
): JSX.Element | string {
    const { municipalitaId, bodyType, zastupitelstvoId } = params;
    const { id, zkratka, strana_barva } = partyData;

    return (
        <Link to={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/subjekty/${id}`} style={{ color: strana_barva }}>
            {zkratka}
        </Link>
    );
}

export function formatVotingAttendanceForComparison(votingAttendance: number): string {
    return `${votingAttendance} %`;
}
